import { cn } from "@/lib/utils";
import type { CampaignExample } from "../../../../data";
import { campaignAccentClasses } from "../../campaignAccent.util";

interface EmailMockProps {
  campaign: CampaignExample;
  footer: string;
}

// The campaign as an email: a window bar, sender, subject line and a branded
// card with a (decorative) button.
const EmailMock = ({ campaign, footer }: EmailMockProps) => {
  const accent = campaignAccentClasses[campaign.accent];
  return (
    <div className="w-full max-w-[272px] overflow-hidden rounded-[14px] border border-line bg-white text-[13px] text-ink shadow-card">
      <div aria-hidden="true" className="flex gap-1.5 bg-paper px-3 py-[9px]">
        <i className="size-[9px] rounded-full bg-line" />
        <i className="size-[9px] rounded-full bg-line" />
        <i className="size-[9px] rounded-full bg-line" />
      </div>
      <div className="flex items-center gap-2.5 px-3 pt-2.5 pb-1.5">
        <span
          aria-hidden="true"
          className={cn(
            "grid size-[30px] shrink-0 place-items-center rounded-full font-extrabold text-white",
            accent.solid,
          )}
        >
          {campaign.brand.initial}
        </span>
        <div className="min-w-0">
          <b className="block text-[12.5px]">{campaign.brand.name}</b>
          <small className="block truncate text-[11px] text-ink-muted">
            {campaign.brand.email}
          </small>
        </div>
      </div>
      <div className="grid gap-px border-b border-line px-3 pt-0.5 pb-2.5">
        <b className="text-[13.5px] leading-[1.3]">{campaign.email.subject}</b>
        <small className="text-[11.5px] text-ink-muted">{campaign.email.preheader}</small>
      </div>
      <div className="grid gap-2.5 bg-cream p-3">
        <div className={cn("grid gap-[5px] rounded-[10px] px-3.5 py-5", accent.art)}>
          <small className="text-[11px] font-bold tracking-[0.06em] uppercase opacity-80">
            {campaign.brand.name}
          </small>
          <b className="text-[1.3rem] leading-[1.15] font-extrabold">
            {campaign.email.heroTitle}
          </b>
        </div>
        <p className="text-[12.5px] leading-[1.45]">{campaign.email.body}</p>
        <span
          aria-hidden="true"
          className={cn(
            "justify-self-start rounded-lg px-3.5 py-[9px] text-[12.5px] font-bold text-white",
            accent.solid,
          )}
        >
          {campaign.email.button}
        </span>
        <small className="text-[10px] leading-[1.35] text-ink-muted">{footer}</small>
      </div>
    </div>
  );
};

export default EmailMock;
